import { initPxTransform } from '@tarojs/taro'
import { createRouter } from '@tarojs/router'
import component from "./app"
import { window } from '@tarojs/runtime'
import { createVue3App } from '@tarojs/plugin-framework-vue3/dist/runtime'
var config = {"router":{"mode":"browser"},"pages":["pages/tab-bar/home","pages/auth/redirect","pages/auth/login","pages/auth/login-by-miniprogram","pages/auth/mobile","pages/auth/login-by-mobile","pages/auth/user-agreement","pages/auth/privacy-agreement","pages/tab-bar/order-center","pages/tab-bar/my","pages/tab-bar/order","pages/app/about","pages/app/call","pages/app/contract-list","pages/app/unsubscribe","pages/app/article-detail","pages/app/test-report","pages/app/agreement","pages/app/guide","pages/app/back-report","pages/order/recharge","pages/order/tran-bank","pages/order/pay-success","pages/order/pay-online","pages/order/company-order-detail","pages/order/get-code","pages/order/agreement","pages/order/order-join","pages/order/order-join-personal","pages/order/join-success","pages/order/order-detail","pages/order/buy-back-order","pages/order/pay-back-order","pages/order/buy-test-order","pages/order/pay-test-order","pages/order/company-order-report","pages/order/buy-back-order-new","pages/order/pay-back-order-new","pages/assist/assist","pages/assist/assist-list","pages/assist/assist-good-list","pages/assist/free-back-personal","pages/assist/assist-rule","pages/wallet/wallet-logs","pages/company/auth-company","pages/company/company-detail","pages/company/change-company","pages/company/bind-idcard","pages/company/bind-mobile-idcard","pages/company/auth-company-flow-induction","pages/company/company-list","pages/company/company-workbench","pages/company/account-list","pages/company/account-detail","pages/company/role-list","pages/company/team-list","pages/company/role-detail","pages/company/team-detail","pages/invoice/my-invoice","pages/invoice/detail-invoice","pages/invoice/apply-invoice","pages/invoice/add-invoice-title","pages/test/index","pages/test/dateTimePickerUse","pages/test/set-token-page","pages/share/home","pages/share/rules","pages/share/advance","pages/share/withdraw","pages/share/active-data","pages/share/business-detail","pages/share/template-invite-detail","pages/share/choose-poster-template","pages/share/download-poster","pages/examination/index","pages/examination/testing","pages/examination/view-report","pages/examination/test-order-list","pages/examination/index-college","pages/examination/college-form","pages/iq/index","pages/iq/iq-testing","pages/iq/iq-view-report","pages/eq/index","pages/eq/eq-testing","pages/eq/eq-view-report","pages/job/index","pages/job/index-simple","pages/job/job-testing","pages/job/job-simple-testing","pages/job/job-view-report","pages/job/job-simple-view-report","pages/job/job-simple-form","pages/sq/index","pages/sq/sq-testing","pages/sq/sq-view-report","pages/mbti/index","pages/mbti/mbti-testing","pages/mbti/mbti-view-report","pages/disc/index","pages/disc/disc-testing","pages/disc/disc-view-report","pages/agency/index","pages/agency/perfect","pages/agency/pay"],"usingComponents":{"dateTimePicker":"./wx-components/date-time-picker/date-time-picker"},"subPackages":[{"root":"pages/app","pages":["about","call","contract-list","unsubscribe","article-detail","test-report","agreement","guide","back-report"]},{"root":"pages/order","pages":["recharge","tran-bank","pay-success","pay-online","company-order-detail","get-code","agreement","order-join","order-join-personal","join-success","order-detail","buy-back-order","pay-back-order","buy-test-order","pay-test-order","company-order-report","buy-back-order-new","pay-back-order-new"]},{"root":"pages/assist","pages":["assist","assist-list","assist-good-list","free-back-personal","assist-rule"]},{"root":"pages/wallet","pages":["wallet-logs"]},{"root":"pages/company","pages":["auth-company","company-detail","change-company","bind-idcard","bind-mobile-idcard","auth-company-flow-induction","company-list","company-workbench","account-list","account-detail","role-list","team-list","role-detail","team-detail"]},{"root":"pages/invoice","pages":["my-invoice","detail-invoice","apply-invoice","add-invoice-title"]},{"root":"pages/test","pages":["index","dateTimePickerUse","set-token-page"]},{"root":"pages/share","pages":["home","rules","advance","withdraw","active-data","business-detail","template-invite-detail","choose-poster-template","download-poster"]},{"root":"pages/examination","pages":["index","testing","view-report","test-order-list","index-college","college-form"]},{"root":"pages/iq","pages":["index","iq-testing","iq-view-report"]},{"root":"pages/eq","pages":["index","eq-testing","eq-view-report"]},{"root":"pages/job","pages":["index","index-simple","job-testing","job-simple-testing","job-view-report","job-simple-view-report","job-simple-form"]},{"root":"pages/sq","pages":["index","sq-testing","sq-view-report"]},{"root":"pages/mbti","pages":["index","mbti-testing","mbti-view-report"]},{"root":"pages/disc","pages":["index","disc-testing","disc-view-report"]},{"root":"pages/agency","pages":["index","perfect","pay"]}],"tabBar":{"custom":false,"color":"#A8A8A8","selectedColor":"#408BF7","list":[{"text":"首页","pagePath":"pages/tab-bar/home","iconPath":"assets/tabbar-icon/home-5-fill(1).png","selectedIconPath":"assets/tabbar-icon/home-5-fill.png"},{"text":"下单","pagePath":"pages/tab-bar/order","iconPath":"assets/tabbar-icon/shoppinged.png","selectedIconPath":"assets/tabbar-icon/shopping.png"},{"text":"订单中心","pagePath":"pages/tab-bar/order-center","iconPath":"assets/tabbar-icon/todo-filled.png","selectedIconPath":"assets/tabbar-icon/todo-fill.png"},{"text":"个人中心","pagePath":"pages/tab-bar/my","iconPath":"assets/tabbar-icon/user-2-filled.png","selectedIconPath":"assets/tabbar-icon/user-2-fill.png"}]},"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"启动项目","navigationBarTextStyle":"black"}}

import { h, createApp } from 'vue'


import { defineCustomElements, applyPolyfills } from '@tarojs/components/loader'
import '@tarojs/components/dist/taro-components/taro-components.css'

import { initVue3Components } from '@tarojs/components/dist-h5/vue3'

applyPolyfills().then(function () {
  defineCustomElements(window)
})

window.__taroAppConfig = config
var tabbarIconPath = []
var tabbarSelectedIconPath = []
tabbarIconPath[0] = typeof require("./assets/tabbar-icon/home-5-fill(1).png") === 'object' ? require("./assets/tabbar-icon/home-5-fill(1).png").default : require("./assets/tabbar-icon/home-5-fill(1).png")
tabbarSelectedIconPath[0] = typeof require("./assets/tabbar-icon/home-5-fill.png") === 'object' ? require("./assets/tabbar-icon/home-5-fill.png").default : require("./assets/tabbar-icon/home-5-fill.png")
tabbarIconPath[1] = typeof require("./assets/tabbar-icon/shoppinged.png") === 'object' ? require("./assets/tabbar-icon/shoppinged.png").default : require("./assets/tabbar-icon/shoppinged.png")
tabbarSelectedIconPath[1] = typeof require("./assets/tabbar-icon/shopping.png") === 'object' ? require("./assets/tabbar-icon/shopping.png").default : require("./assets/tabbar-icon/shopping.png")
tabbarIconPath[2] = typeof require("./assets/tabbar-icon/todo-filled.png") === 'object' ? require("./assets/tabbar-icon/todo-filled.png").default : require("./assets/tabbar-icon/todo-filled.png")
tabbarSelectedIconPath[2] = typeof require("./assets/tabbar-icon/todo-fill.png") === 'object' ? require("./assets/tabbar-icon/todo-fill.png").default : require("./assets/tabbar-icon/todo-fill.png")
tabbarIconPath[3] = typeof require("./assets/tabbar-icon/user-2-filled.png") === 'object' ? require("./assets/tabbar-icon/user-2-filled.png").default : require("./assets/tabbar-icon/user-2-filled.png")
tabbarSelectedIconPath[3] = typeof require("./assets/tabbar-icon/user-2-fill.png") === 'object' ? require("./assets/tabbar-icon/user-2-fill.png").default : require("./assets/tabbar-icon/user-2-fill.png")

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (var i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  Object.assign({
  path: 'pages/tab-bar/home',
  load: function(context, params) {
    const page = import("./pages/tab-bar/home")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"enableShareAppMessage":true,"navigationBarTitleText":"欢创背调"}),Object.assign({
  path: 'pages/auth/redirect',
  load: function(context, params) {
    const page = import("./pages/auth/redirect")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true}),Object.assign({
  path: 'pages/auth/login',
  load: function(context, params) {
    const page = import("./pages/auth/login")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"授权登录"}),Object.assign({
  path: 'pages/auth/login-by-miniprogram',
  load: function(context, params) {
    const page = import("./pages/auth/login-by-miniprogram")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"用户登录"}),Object.assign({
  path: 'pages/auth/mobile',
  load: function(context, params) {
    const page = import("./pages/auth/mobile")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"绑定手机号"}),Object.assign({
  path: 'pages/auth/login-by-mobile',
  load: function(context, params) {
    const page = import("./pages/auth/login-by-mobile")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"手机号登录"}),Object.assign({
  path: 'pages/auth/user-agreement',
  load: function(context, params) {
    const page = import("./pages/auth/user-agreement")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"用户协议"}),Object.assign({
  path: 'pages/auth/privacy-agreement',
  load: function(context, params) {
    const page = import("./pages/auth/privacy-agreement")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"隐私政策"}),Object.assign({
  path: 'pages/tab-bar/order-center',
  load: function(context, params) {
    const page = import("./pages/tab-bar/order-center")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"订单中心"}),Object.assign({
  path: 'pages/tab-bar/my',
  load: function(context, params) {
    const page = import("./pages/tab-bar/my")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"enableShareAppMessage":true,"navigationBarTitleText":"个人中心"}),Object.assign({
  path: 'pages/tab-bar/order',
  load: function(context, params) {
    const page = import("./pages/tab-bar/order")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":false,"enableShareAppMessage":true,"navigationBarTitleText":"下单"}),Object.assign({
  path: 'pages/app/about',
  load: function(context, params) {
    const page = import("./pages/app/about")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"关于我们"}),Object.assign({
  path: 'pages/app/call',
  load: function(context, params) {
    const page = import("./pages/app/call")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"联系我们"}),Object.assign({
  path: 'pages/app/contract-list',
  load: function(context, params) {
    const page = import("./pages/app/contract-list")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"我的合同"}),Object.assign({
  path: 'pages/app/unsubscribe',
  load: function(context, params) {
    const page = import("./pages/app/unsubscribe")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"账号注销"}),Object.assign({
  path: 'pages/app/article-detail',
  load: function(context, params) {
    const page = import("./pages/app/article-detail")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/app/test-report',
  load: function(context, params) {
    const page = import("./pages/app/test-report")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/app/agreement',
  load: function(context, params) {
    const page = import("./pages/app/agreement")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"用户协议"}),Object.assign({
  path: 'pages/app/guide',
  load: function(context, params) {
    const page = import("./pages/app/guide")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/app/back-report',
  load: function(context, params) {
    const page = import("./pages/app/back-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"背调报告"}),Object.assign({
  path: 'pages/order/recharge',
  load: function(context, params) {
    const page = import("./pages/order/recharge")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"充值"}),Object.assign({
  path: 'pages/order/tran-bank',
  load: function(context, params) {
    const page = import("./pages/order/tran-bank")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"对公转账"}),Object.assign({
  path: 'pages/order/pay-success',
  load: function(context, params) {
    const page = import("./pages/order/pay-success")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"支付金额"}),Object.assign({
  path: 'pages/order/pay-online',
  load: function(context, params) {
    const page = import("./pages/order/pay-online")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"在线支付"}),Object.assign({
  path: 'pages/order/company-order-detail',
  load: function(context, params) {
    const page = import("./pages/order/company-order-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"查看详情"}),Object.assign({
  path: 'pages/order/get-code',
  load: function(context, params) {
    const page = import("./pages/order/get-code")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"二维码"}),Object.assign({
  path: 'pages/order/agreement',
  load: function(context, params) {
    const page = import("./pages/order/agreement")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"用户协议"}),Object.assign({
  path: 'pages/order/order-join',
  load: function(context, params) {
    const page = import("./pages/order/order-join")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"填写个人信息"}),Object.assign({
  path: 'pages/order/order-join-personal',
  load: function(context, params) {
    const page = import("./pages/order/order-join-personal")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/order/join-success',
  load: function(context, params) {
    const page = import("./pages/order/join-success")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"提交成功"}),Object.assign({
  path: 'pages/order/order-detail',
  load: function(context, params) {
    const page = import("./pages/order/order-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"订单详情"}),Object.assign({
  path: 'pages/order/buy-back-order',
  load: function(context, params) {
    const page = import("./pages/order/buy-back-order")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"背调下单"}),Object.assign({
  path: 'pages/order/pay-back-order',
  load: function(context, params) {
    const page = import("./pages/order/pay-back-order")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"支付订单"}),Object.assign({
  path: 'pages/order/buy-test-order',
  load: function(context, params) {
    const page = import("./pages/order/buy-test-order")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"测试下单"}),Object.assign({
  path: 'pages/order/pay-test-order',
  load: function(context, params) {
    const page = import("./pages/order/pay-test-order")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"测试下单"}),Object.assign({
  path: 'pages/order/company-order-report',
  load: function(context, params) {
    const page = import("./pages/order/company-order-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业报告"}),Object.assign({
  path: 'pages/order/buy-back-order-new',
  load: function(context, params) {
    const page = import("./pages/order/buy-back-order-new")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"背调下单"}),Object.assign({
  path: 'pages/order/pay-back-order-new',
  load: function(context, params) {
    const page = import("./pages/order/pay-back-order-new")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"支付订单"}),Object.assign({
  path: 'pages/assist/assist',
  load: function(context, params) {
    const page = import("./pages/assist/assist")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"助力0元使用","enableShareAppMessage":true}),Object.assign({
  path: 'pages/assist/assist-list',
  load: function(context, params) {
    const page = import("./pages/assist/assist-list")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"我的助力"}),Object.assign({
  path: 'pages/assist/assist-good-list',
  load: function(context, params) {
    const page = import("./pages/assist/assist-good-list")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"助力0元使用"}),Object.assign({
  path: 'pages/assist/free-back-personal',
  load: function(context, params) {
    const page = import("./pages/assist/free-back-personal")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":""}),Object.assign({
  path: 'pages/assist/assist-rule',
  load: function(context, params) {
    const page = import("./pages/assist/assist-rule")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":""}),Object.assign({
  path: 'pages/wallet/wallet-logs',
  load: function(context, params) {
    const page = import("./pages/wallet/wallet-logs")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"查看明细"}),Object.assign({
  path: 'pages/company/auth-company',
  load: function(context, params) {
    const page = import("./pages/company/auth-company")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业认证"}),Object.assign({
  path: 'pages/company/company-detail',
  load: function(context, params) {
    const page = import("./pages/company/company-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业认证"}),Object.assign({
  path: 'pages/company/change-company',
  load: function(context, params) {
    const page = import("./pages/company/change-company")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true}),Object.assign({
  path: 'pages/company/bind-idcard',
  load: function(context, params) {
    const page = import("./pages/company/bind-idcard")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"绑定身份证"}),Object.assign({
  path: 'pages/company/bind-mobile-idcard',
  load: function(context, params) {
    const page = import("./pages/company/bind-mobile-idcard")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业认证"}),Object.assign({
  path: 'pages/company/auth-company-flow-induction',
  load: function(context, params) {
    const page = import("./pages/company/auth-company-flow-induction")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"立即入驻"}),Object.assign({
  path: 'pages/company/company-list',
  load: function(context, params) {
    const page = import("./pages/company/company-list")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业列表"}),Object.assign({
  path: 'pages/company/company-workbench',
  load: function(context, params) {
    const page = import("./pages/company/company-workbench")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"企业控制台"}),Object.assign({
  path: 'pages/company/account-list',
  load: function(context, params) {
    const page = import("./pages/company/account-list")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/company/account-detail',
  load: function(context, params) {
    const page = import("./pages/company/account-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"编辑企业成员"}),Object.assign({
  path: 'pages/company/role-list',
  load: function(context, params) {
    const page = import("./pages/company/role-list")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/company/team-list',
  load: function(context, params) {
    const page = import("./pages/company/team-list")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/company/role-detail',
  load: function(context, params) {
    const page = import("./pages/company/role-detail")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/company/team-detail',
  load: function(context, params) {
    const page = import("./pages/company/team-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"编辑企业部门"}),Object.assign({
  path: 'pages/invoice/my-invoice',
  load: function(context, params) {
    const page = import("./pages/invoice/my-invoice")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"我的发票"}),Object.assign({
  path: 'pages/invoice/detail-invoice',
  load: function(context, params) {
    const page = import("./pages/invoice/detail-invoice")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/invoice/apply-invoice',
  load: function(context, params) {
    const page = import("./pages/invoice/apply-invoice")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"确认开票"}),Object.assign({
  path: 'pages/invoice/add-invoice-title',
  load: function(context, params) {
    const page = import("./pages/invoice/add-invoice-title")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"添加发票抬头"}),Object.assign({
  path: 'pages/test/index',
  load: function(context, params) {
    const page = import("./pages/test/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":false}),Object.assign({
  path: 'pages/test/dateTimePickerUse',
  load: function(context, params) {
    const page = import("./pages/test/dateTimePickerUse")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true}),Object.assign({
  path: 'pages/test/set-token-page',
  load: function(context, params) {
    const page = import("./pages/test/set-token-page")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true}),Object.assign({
  path: 'pages/share/home',
  load: function(context, params) {
    const page = import("./pages/share/home")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"enableShareAppMessage":true,"navigationBarTitleText":"分享好友得现金"}),Object.assign({
  path: 'pages/share/rules',
  load: function(context, params) {
    const page = import("./pages/share/rules")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"活动规则"}),Object.assign({
  path: 'pages/share/advance',
  load: function(context, params) {
    const page = import("./pages/share/advance")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"提现"}),Object.assign({
  path: 'pages/share/withdraw',
  load: function(context, params) {
    const page = import("./pages/share/withdraw")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"提现"}),Object.assign({
  path: 'pages/share/active-data',
  load: function(context, params) {
    const page = import("./pages/share/active-data")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"活动数据"}),Object.assign({
  path: 'pages/share/business-detail',
  load: function(context, params) {
    const page = import("./pages/share/business-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"交易记录详情"}),Object.assign({
  path: 'pages/share/template-invite-detail',
  load: function(context, params) {
    const page = import("./pages/share/template-invite-detail")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"邀请好友数据"}),Object.assign({
  path: 'pages/share/choose-poster-template',
  load: function(context, params) {
    const page = import("./pages/share/choose-poster-template")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"海报模板选择"}),Object.assign({
  path: 'pages/share/download-poster',
  load: function(context, params) {
    const page = import("./pages/share/download-poster")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"海报模板选择"}),Object.assign({
  path: 'pages/examination/index',
  load: function(context, params) {
    const page = import("./pages/examination/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"九型人格测试"}),Object.assign({
  path: 'pages/examination/testing',
  load: function(context, params) {
    const page = import("./pages/examination/testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"九型人格测试"}),Object.assign({
  path: 'pages/examination/view-report',
  load: function(context, params) {
    const page = import("./pages/examination/view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"九型人格测试"}),Object.assign({
  path: 'pages/examination/test-order-list',
  load: function(context, params) {
    const page = import("./pages/examination/test-order-list")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"测评报告"}),Object.assign({
  path: 'pages/examination/index-college',
  load: function(context, params) {
    const page = import("./pages/examination/index-college")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"九型人格测试"}),Object.assign({
  path: 'pages/examination/college-form',
  load: function(context, params) {
    const page = import("./pages/examination/college-form")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/iq/index',
  load: function(context, params) {
    const page = import("./pages/iq/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"瑞文国际IQ测试"}),Object.assign({
  path: 'pages/iq/iq-testing',
  load: function(context, params) {
    const page = import("./pages/iq/iq-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"瑞文国际IQ测试"}),Object.assign({
  path: 'pages/iq/iq-view-report',
  load: function(context, params) {
    const page = import("./pages/iq/iq-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"瑞文国际IQ测试"}),Object.assign({
  path: 'pages/eq/index',
  load: function(context, params) {
    const page = import("./pages/eq/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"国际标准EQ测试"}),Object.assign({
  path: 'pages/eq/eq-testing',
  load: function(context, params) {
    const page = import("./pages/eq/eq-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"国际标准EQ测试"}),Object.assign({
  path: 'pages/eq/eq-view-report',
  load: function(context, params) {
    const page = import("./pages/eq/eq-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"国际标准EQ测试"}),Object.assign({
  path: 'pages/job/index',
  load: function(context, params) {
    const page = import("./pages/job/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试"}),Object.assign({
  path: 'pages/job/index-simple',
  load: function(context, params) {
    const page = import("./pages/job/index-simple")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试"}),Object.assign({
  path: 'pages/job/job-testing',
  load: function(context, params) {
    const page = import("./pages/job/job-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试【评测报告】"}),Object.assign({
  path: 'pages/job/job-simple-testing',
  load: function(context, params) {
    const page = import("./pages/job/job-simple-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试【评测报告】"}),Object.assign({
  path: 'pages/job/job-view-report',
  load: function(context, params) {
    const page = import("./pages/job/job-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试报告"}),Object.assign({
  path: 'pages/job/job-simple-view-report',
  load: function(context, params) {
    const page = import("./pages/job/job-simple-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"霍兰德职业兴趣测试报告"}),Object.assign({
  path: 'pages/job/job-simple-form',
  load: function(context, params) {
    const page = import("./pages/job/job-simple-form")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/sq/index',
  load: function(context, params) {
    const page = import("./pages/sq/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"舒伯职业价值观测试"}),Object.assign({
  path: 'pages/sq/sq-testing',
  load: function(context, params) {
    const page = import("./pages/sq/sq-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"舒伯职业价值观测试"}),Object.assign({
  path: 'pages/sq/sq-view-report',
  load: function(context, params) {
    const page = import("./pages/sq/sq-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"舒伯职业价值观测试"}),Object.assign({
  path: 'pages/mbti/index',
  load: function(context, params) {
    const page = import("./pages/mbti/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"MBTI性格测试"}),Object.assign({
  path: 'pages/mbti/mbti-testing',
  load: function(context, params) {
    const page = import("./pages/mbti/mbti-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"MBTI性格测试"}),Object.assign({
  path: 'pages/mbti/mbti-view-report',
  load: function(context, params) {
    const page = import("./pages/mbti/mbti-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"MBTI人格测试"}),Object.assign({
  path: 'pages/disc/index',
  load: function(context, params) {
    const page = import("./pages/disc/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"DISC性格测试"}),Object.assign({
  path: 'pages/disc/disc-testing',
  load: function(context, params) {
    const page = import("./pages/disc/disc-testing")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"DISC性格测试"}),Object.assign({
  path: 'pages/disc/disc-view-report',
  load: function(context, params) {
    const page = import("./pages/disc/disc-view-report")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"DISC人格测试"}),Object.assign({
  path: 'pages/agency/index',
  load: function(context, params) {
    const page = import("./pages/agency/index")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"手机号登录"}),Object.assign({
  path: 'pages/agency/perfect',
  load: function(context, params) {
    const page = import("./pages/agency/perfect")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"完善资料"}),Object.assign({
  path: 'pages/agency/pay',
  load: function(context, params) {
    const page = import("./pages/agency/pay")
    return [page, context, params]
  }
}, {"enablePullDownRefresh":true,"navigationBarTitleText":"支付"})
]


initVue3Components(component)

var inst = createVue3App(component, h, config)
createRouter(inst, config, h)
initPxTransform({
  designWidth: 375,
  deviceRatio: {"375":2,"640":1.17,"750":1,"828":0.905},
  baseFontSize: 20
})
